import { css, styled } from "styled-components";

const StyledInput = styled.input`
  outline: none;
  color: ${({ theme }) => theme.colors.black};

  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;

  padding: 1rem;
  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.surfaceQuaternary};

  ::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  transition:
    box-shadow 0.2s ease 0s,
    transform 0.2s ease 0s;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Element = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 120%;
  & > a {
    margin-left: 0.25rem;
  }

  strong {
    color: ${({ theme }) => theme.colors.black};
  }

  table,
  th,
  td {
    border: 1px solid ${({ theme }) => theme.colors.border};

    border-collapse: collapse;
  }
  table {
    margin-top: 0.5rem;
    width: 100%;
  }
  td {
    padding: 0.5rem;
  }
`;

const NetworkContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  overflow-y: auto;
`;

const Network = styled.div<{ $isActive: boolean; $disabled: boolean }>`
  cursor: pointer;

  flex-shrink: 0;
  width: 5.2rem;

  display: flex;
  align-items: center;
  gap: 0.25rem;

  padding: 0.25rem;

  border-radius: 0.625rem;
  border: 1px solid transparent;
  opacity: 0.7;

  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      border: 1px solid ${theme.colors.borderNetwork};
      background: ${theme.colors.surfaceNetwork};
      opacity: 1;
    `}
  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `}

  & > svg {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.manrope};
  font-style: normal;
  font-weight: 700;
  line-height: 0.625rem;
`;

export default {
  StyledInput,
  Error,
  List,
  Element,
  NetworkContainer,
  Network,
  Text,
};
